export const aciChildenClub = {
    iconName: 'childen-club',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: [
            {
                attr: {
                    d: 'M20.642 16.913a11.66 11.66 0 01-16.49 0M16.837 10.83c1.01.923 2.598 2.069 3.973 1.725M8.047 19.49a4.999 4.999 0 019.913-.57',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M6.396 18.669a6.648 6.648 0 012.013-5.356 1.11 1.11 0 00.254-1.227L7.183 8.54a.555.555 0 00-.727-.296 1.666 1.666 0 01-1.279-3.077l2.566-1.069a1.11 1.11 0 011.452.598l1.6 3.844a1.11 1.11 0 001.024.684h2.883a2.22 2.22 0 012.221 2.222v.707a1.111 1.111 0 00.397.851 6.649 6.649 0 012.37 4.764',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M8.071 4.016c1.504-.705 2.87-.267 3.3.765l2.221 4.442M15.257 9.293v2.152a1.11 1.11 0 01-1.11 1.11h-1.11a1.111 1.111 0 01-1.111-1.11V9.224',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M7.484 6.54a.278.278 0 110-.556M7.483 6.54a.278.278 0 100-.556',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                },
            },
        ],
    },
};
